import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'congratulations',
    templateUrl: './congratulations.component.html',
    standalone: false
})
export class CongratulationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
